import React, { useState, useEffect } from "react";
import "../Styles/dashboardfrontpage.css";
import { PieChart, Pie, Cell } from "recharts";
import {
  Users,
  UserCircle2,
  LogOut,
  ImagePlus,
  UserPlus,
  UsersRound,
  Contact,
  ArrowRight,
} from "lucide-react";

// Change this if your backend runs on a different host/port
const API_BASE_URL = "";

const quickActions = [
  {
    title: "Upload Event Photos",
    subtitle: "Add a new photos to the gallery",
    icon: "/assets/upload.png",
    isImage: true,
    bg: "#FDECE3",
    fg: "#F0703C",
    arrowBg: "#F0703C",
    page: "gallery",
  },
  {
    title: "Community Members",
    subtitle: "Manage your HR community",
    icon: "/assets/People.png",
    isImage: true,
    bg: "#E4F8ED",
    fg: "#22B573",
    arrowBg: "#22B573",
    page: "community",
  },
  {
    title: "View Subscribers",
    subtitle: "Manage your Subscribers",
    icon: "/assets/sel.png",
    isImage: true,
    bg: "#E5EEFF",
    fg: "#3B6FEA",
    arrowBg: "#3B6FEA",
    page: "subscribers",
  },
  {
    title: "Event Registrations",
    subtitle: "See all sign-ups",
    icon: "/assets/Registration.png",
    isImage: true,
    bg: "#F1E9FE",
    fg: "#8B5CF6",
    arrowBg: "#8B5CF6",
    page: "registration",
  },
];

const registrations = [
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Paid",
  },
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Unpaid",
  },
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Paid",
  },
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Unpaid",
  },
];


export default function AdminDashboard({ onNavigate }) {
  // ---- Live counts fetched from backend ----
  const [counts, setCounts] = useState({
    communityMembers: 0,
    collaborators: 0,
    registrations: 0,
    subscribers: 0,
  });
  const [loadingCounts, setLoadingCounts] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
       const [communityRes, collabRes, regRes, subRes] = await Promise.all([
  fetch(`${API_BASE_URL}/api/community-members`),
  fetch(`${API_BASE_URL}/api/collaborators`),
  fetch(`${API_BASE_URL}/api/registrations`),
  fetch(`${API_BASE_URL}/api/subscribers`),
]);

const [communityData, collabData, regData, subData] = await Promise.all([
  communityRes.json(),
  collabRes.json(),
  regRes.json(),
  subRes.json(),
]);

setCounts({
  communityMembers:
    typeof communityData?.total === "number"
      ? communityData.total
      : Array.isArray(communityData?.members)
      ? communityData.members.length
      : 0,

  collaborators: Array.isArray(collabData) ? collabData.length : 0,

  registrations: Array.isArray(regData) ? regData.length : 0,

  subscribers: Array.isArray(subData) ? subData.length : 0,
});
      } catch (err) {
        console.error("Failed to load dashboard counts:", err);
      } finally {
        setLoadingCounts(false);
      }
    };

    fetchCounts();
  }, []);

  // ---- Stat cards now pull live values from state ----
  const stats = [
    {
      label: "Total Community Members",
      value: loadingCounts ? "..." : counts.communityMembers.toLocaleString(),
      icon: "/assets/Management.png",
      isImage: true,
      bg: "#FDECE3",
      fg: "#F0703C",
    },
    {
      label: "Total Collaborators",
      value: loadingCounts ? "..." : counts.collaborators.toLocaleString(),
      icon: "/assets/coll.png",
      isImage: true,
      bg: "#F1E9FE",
      fg: "#8B5CF6",
    },
    {
      label: "Total Subscribers",
      value: loadingCounts ? "..." : counts.subscribers.toLocaleString(),
      icon: "/assets/su.png",
      isImage: true,
      bg: "#E5EEFF",
      fg: "#3B6FEA",
    },
    {
      label: "HR Festival Registrations",
      value: loadingCounts ? "..." : counts.registrations.toLocaleString(),
      icon: "/assets/reg.png",
      isImage: true,
      bg: "#E4F8ED",
      fg: "#22B573",
    },
    
  ];

  return (
    <div className="vhrd">
      

      <div className="welcome">
        <h2>Welcome to the Admin Dashboard!</h2>
        <p>
          Welcome back to Vanakkam HRD Administration. Manage community
          members, event registrations and gallery from one place.
        </p>
      </div>

      <div className="stat-grid">
        {stats.map((s) => (
          <div className="front-stat-card" key={s.label}>
            <div className="stat-icon" style={{ background: s.bg }}>
              {s.isImage ? (
                <img src={s.icon} alt={s.label} className="stat-icon-img" />
              ) : (
                <s.icon style={{ color: s.fg }} />
              )}
            </div>
            <div>
              <div className="stat-value">{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="panel quick-panel">
        <div className="section-title">Quick Actions</div>
        <div className="quick-grid">
          {quickActions.map((q) => (
            <div className="quick-card" key={q.title}>
              <div className="quick-icon" style={{ background: q.bg }}>
                <img src={q.icon} alt={q.title} className="quick-icon-img" />
              </div>
              <div className="quick-row">
                <div>
                  <p className="quick-title">{q.title}</p>
                  <p className="quick-subtitle">{q.subtitle}</p>
                </div>
                <div
  className="quick-arrow"
  style={{ background: q.arrowBg, cursor: "pointer" }}
  onClick={() => onNavigate && onNavigate(q.page)}
>
  <ArrowRight />
</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bottom-row">
        <div className="panel">
          <h3>Event Summary</h3>
          <div className="donut-wrap">
            <PieChart width={180} height={180}>
  <Pie
    data={[{ value: counts.registrations }]}
    dataKey="value"
    innerRadius={58}
    outerRadius={82}
    startAngle={90}
    endAngle={-270}
    stroke="none"
    fill="#22C55E"
  >
    <Cell fill="#22C55E" />
  </Pie>
</PieChart>
            <div
              className="donut-center"
              style={{ marginTop: -130, marginBottom: 60 }}
            >
              <div style={{ fontSize: 11, color: "var(--muted)" }}>Total</div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>
  {loadingCounts ? "..." : counts.registrations.toLocaleString()}
</div>
            </div>
            
          </div>
        </div>

        <div className="panel">
          <h3>Recent Registrations</h3>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Company</th>
                <th>Designation</th>
                <th>Contact</th>
                <th>Payment Status</th>
              </tr>
            </thead>
            <tbody>
              {registrations.map((r, i) => (
                <tr key={i}>
                  <td>
                    <div className="person-cell">
                      <div className="avatar" />
                      {r.name}
                    </div>
                  </td>
                  <td>{r.company}</td>
                  <td>{r.designation}</td>
                  <td>{r.contact}</td>
                  <td>
                    <span className={`status-pill ${r.status.toLowerCase()}`}>
                      {r.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <a className="view-all">
            View All Registrations <ArrowRight />
          </a>
        </div>
      </div>
    </div>
  );
}